import { BeamProvider } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { NavigationContextProvider } from "src/components";
import { AppNotificationsProvider } from "src/contexts/AppNotificationsContext";
import { BlueprintProvider } from "src/contexts/BlueprintContext";
import { FeatureFlagProvider } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { TrackedJobsProvider } from "src/contexts/TrackedJobsContext";
import { LocalCssReset } from "src/utils/LocalCssReset";

/**
 * SHARED — logged-in provider stack used by both routing styles.
 *
 * Legacy: `App` → `PageLayout` → `AppProviders`
 * Data router: `AppShell` → `AppProviders` → `AuthenticatedShell`
 */
export function AppProviders(props: PropsWithChildren) {
  return (
    <BeamProvider>
      <LocalCssReset />
      <NavigationContextProvider>
        <BlueprintProvider>
          <FeatureFlagProvider>
            <AppNotificationsProvider>
              <TrackedJobsProvider>{props.children}</TrackedJobsProvider>
            </AppNotificationsProvider>
          </FeatureFlagProvider>
        </BlueprintProvider>
      </NavigationContextProvider>
    </BeamProvider>
  );
}
